<template>
  <div class="backpack" @mouseover="$emit('show')" @mouseleave="$emit('hide')">
    <div class="header">
      <img @click="toShopping" src="./img/shopping.png" alt="" />
      <div @click="toShopping" style="cursor: pointer">猎鹰商城 ></div>
    </div>
    <div class="content">
      <div v-if="backpack.length > 0" class="swiper-container swiper-backpack">
        <div class="swiper-wrapper">
          <div class="swiper-slide list" v-for="(items, index) in backpack" :key="index">
            <div :class="['list-item', listActive === i ? 'list-item-active' : '']" @click="changeProps(i, item)" v-for="(item, i) in items" :key="i">
              <div class="list-pic">
                <img :src="item.icon" />
              </div>
              <div class="text1">{{ item.title }}</div>
              <div class="text2" v-if="item.quantity > 0 && item.type !== 102">{{ item.quantity + "个" }}</div>
              <!-- <div class="text2" v-if="item.price > 0">{{ item.price_type === 1 ? item.price + "克拉" : item.price + "鹰钻" }}</div> -->
              <div class="text2" v-if="item.type === 102">{{ stampToDay(item.exp_time) + "天" }}</div>
              <img class="select-angle" v-if="item.selected === 1" src="./img/selected.png" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-pagination"></div>
      <div v-if="backpack.length === 0" class="no-data">
        <img src="./img/no-backpack.png" alt="" />
        <div>背包里面看起来什么都没有哦~</div>
      </div>
    </div>
    <div class="box-down" v-if="propsType === 0">
      <div class="btn" :class="active == 1 ? 'btn-active' : ''" @click="changeNum(1)">1</div>
      <div class="btn" :class="active == 10 ? 'btn-active' : ''" @click="changeNum(10)">10</div>
      <div class="btn" :class="active == 66 ? 'btn-active' : ''" @click="changeNum(66)">66</div>
      <div class="btn" :class="active == 1314 ? 'btn-active' : ''" @click="changeNum(1314)">1314</div>
      <div class="btn btn-send" @click="sendGiftMultipleHit">连击</div>
    </div>
    <div class="box-down" v-if="propsType === 1">
      <div class="btn" :class="active == 1 ? 'btn-active' : ''" @click="changeNum(1)">1</div>
      <div class="btn" :class="active == 10 ? 'btn-active' : ''" @click="changeNum(10)">10</div>
      <div class="btn" :class="active == 66 ? 'btn-active' : ''" @click="changeNum(66)">66</div>
      <div class="btn" :class="active == 1314 ? 'btn-active' : ''" @click="changeNum(1314)">1314</div>
      <div class="btn btn-send" @click="sendGift">{{ sendGiftText }}</div>
    </div>
    <div class="box-down" v-if="propsType === 2">
      <div class="btn" :class="active == 1 ? 'btn-active' : ''" @click="changeNum(1)">1</div>
      <div class="btn" :class="active == 10 ? 'btn-active' : ''" @click="changeNum(10)">10</div>
      <div class="btn" :class="active == 66 ? 'btn-active' : ''" @click="changeNum(66)">66</div>
      <div class="btn" :class="active == 1314 ? 'btn-active' : ''" @click="changeNum(1314)">1314</div>
      <div class="btn btn-send" @click="sendGift">{{ sendGiftText }}</div>
    </div>
    <div class="box-down box-down-use" v-if="propsType > 2">
      <div class="btn btn-send" @click="useProps">使用</div>
    </div>
    <div class="bottom-arrow"></div>
  </div>
</template>

<script>
import Swiper, { Pagination } from "swiper";
Swiper.use([Pagination]);
import { post } from "@/util/http";
import { stampToDay } from "@/util/time";
import { mapState, mapMutations } from "vuex";

export default {
  name: "backpack",
  props: {
    userBackpack: {
      type: Array,
      default() {
        return [];
      },
    },
    showBackpack: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  data() {
    return {
      backpack: [],
      active: 1,
      activeNum: 1,
      listActive: 0,
      propsType: 3,
      giftId: 0,
      gift: {},
      sendGiftText: "赠送",
      timeId: null,
      isSend: false,
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  watch: {
    userBackpack(n, o) {
      // console.log(n, "watch:++++++++++++++++++");
      if (!n || n.length === 0) return;
      this.propsType = this.userBackpack[0].type;
      this.giftId = this.userBackpack[0].gid;
      this.gift = this.userBackpack[0];
      this.listActive = 0;
      this.backpack = [];
      if (n.length <= 8) {
        this.backpack.push(n.slice(0, 8));
      } else if (8 < n.length <= 16) {
        this.backpack.push(n.slice(0, 8));
        this.backpack.push(n.slice(8, 16));
      }
      // console.log(this.backpack, this.listActive, "watch:++++++++++++++++++");
    },
    showBackpack(n, o) {
      this.$nextTick(() => {
        new Swiper(".swiper-backpack", {
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
        });
      });
    },
  },
  mounted() {},
  methods: {
    ...mapMutations(["toggleLogin"]),

    stampToDay,
    toShopping() {
      this.$router.push("/mall");
    },
    changeNum(index) {
      this.active = index;
      this.activeNum = index;
    },
    sendGiftMultipleHit() {
      this.$emit("sendGift", this.activeNum, this.gift);
    },
    sendGift() {
      if (this.isSend) return;
      this.$emit("sendGift", this.activeNum, this.gift);
      this.isSend = true;
      let time = 3;
      this.sendGiftText = "剩余" + time + "s";
      this.timeId = setInterval(() => {
        time--;
        this.sendGiftText = "剩余" + time + "s";
        if (time <= 0) {
          this.sendGiftText = "赠送";
          this.isSend = false;
          clearInterval(this.timeId);
        }
      }, 1000);
    },
    changeProps(i, item) {
      this.listActive = i;
      this.propsType = item.type;
      this.giftId = item.gid;
      this.gift = item;
      console.log(this.propsType, "type=====================");
    },
    useProps() {
      if (!this.userInfo.id) {
        this.toggleLogin();
        return;
      }
      this.$emit("hide");
      console.log(this.propsType, this.listActive, "this.propsType");
      if (this.propsType === 102) {
        this.useBackPackProps();
        return;
      }
      this.$emit("useProps", this.propsType, this.giftId);
    },
    useBackPackProps() {
      post({
        url: "/api/live/useBackPackProps",
        data: { props_id: this.giftId, props_type: this.propsType, user_id: this.userInfo.id },
      }).then((res) => {
        console.log(res, "data");
        this.$emit("reloadBackpack");
      });
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .swiper-pagination-bullet {
  background: rgba(2, 168, 162, 1);
  width: 0.06rem;
  height: 0.06rem;
  margin-right: 0.04rem;
}
::v-deep .swiper-pagination-bullet-active {
  background: #02a8a2;
  width: 0.16rem;
  border-radius: 0.06rem;
}
.swiper-pagination {
  left: 1.74rem;
  bottom: 0.6rem;
}

.backpack {
  width: 3.75rem;
  position: absolute;
  right: 0.06rem;
  bottom: 0.6rem;
  z-index: 6;
}
.header {
  height: 0.56rem;
  background: url("./img/backpack-header.png");
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: #02a8a2;
  padding-right: 0.12rem;
  img {
    width: 0.28rem;
    height: 0.28rem;
    margin-right: 0.08rem;
    cursor: pointer;
  }
}
.content {
  height: 2.22rem;
  background: #fff;
  padding: 0.1rem 0 0 0.12rem;
  .list {
    display: flex;
    flex-wrap: wrap;
    .list-item {
      width: 0.8rem;
      height: 0.87rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border: 0.01rem solid transparent;
      background-color: #f9f9fb;
      border-radius: 0.05rem;
      margin-right: 0.1rem;
      margin-bottom: 0.1rem;
      cursor: pointer;
      position: relative;
      padding: 8px 0;

      .list-pic {
        flex: 1;
        margin-bottom: 0.03rem;
        display: flex;
        justify-content: center;
        img {
          width: 0.48rem;
          object-fit: contain;
        }
      }
      .text1 {
        font-size: 0.12rem;
        color: #333;
      }
      .text2 {
        font-size: 0.12rem;
        color: #999;
        margin-top: 0.02rem;
        transform: scale(0.83);
      }
      .select-angle {
        width: 0.33rem;
        height: 0.32rem;
        position: absolute;
        top: 0;
        right: 0;
      }
    }
    .list-item-active {
      background-clip: padding-box, border-box;
      background-origin: padding-box, border-box;
      background-image: linear-gradient(to right, #fbfbfb, #fbfbfb), linear-gradient(90deg, #29f19c 0%, #02a1f9 100%);
      box-shadow: 0px 0px 8px rgba(0, 255, 163, 0.33);
    }
  }
  .no-data {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #999;
    font-size: 0.12rem;
    img {
      width: 1.4rem;
      height: 1.4rem;
      margin-top: 0.2rem;
    }
  }
}

.box-down {
  height: 0.52rem;
  background-color: #eee;
  border-radius: 0px 0px 0.1rem 0.1rem;
  padding: 0.12rem;
  display: flex;
  justify-content: space-between;
  .btn {
    width: 0.54rem;
    height: 0.28rem;
    color: #666;
    background-color: #fff;
    border-radius: 2px;
    font-size: 0.14rem;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  .btn-active {
    color: #fff;
    background: #02a8a2;
  }
  .btn-send {
    background: linear-gradient(90deg, #29f19c 0%, #02a1f9 100%);
    width: 0.64rem;
    height: 0.28rem;
    background-color: #fff;
    border-radius: 2px;
    color: #fff;
    margin-left: 0.2rem;
  }
}
.box-down-use {
  justify-content: flex-end;
}
.bottom-arrow {
  height: 0.04rem;
  position: absolute;
  bottom: 0;
  left: 82%;
  transform: translateX(-50%);
  background: #eee;

  &::after {
    content: "";
    width: 0;
    height: 0;
    position: absolute;
    bottom: -0.15rem;
    left: 82%;
    transform: translateX(-50%);
    border: 0.1rem solid transparent;
    border-top: 0.08rem solid #eee;
  }
}
</style>
